import type { IResourceName } from 'volta/models/base-model';
import BaseModel from 'volta/models/base-model';
import { collectionCommand, resourceCommand as command } from 'volta/utils/api';

import { attr, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { TCustomFieldValues } from 'volta/models/types/custom-field-definition';
import type { ICreateSupplierCmd, IUpdateSupplierCmd } from 'volta/models/types/supplier';
import type UserProfile from 'volta/models/user-profile';

export const SupplierResourceName: IResourceName = {
  singular: 'supplier',
  plural: 'suppliers',
  table: 'suppliers'
};

export enum SupplierEvents {
  SupplierCreated = 'SupplierCreated',
  SupplierUpdated = 'SupplierUpdated',
  SupplierDeleted = 'SupplierDeleted'
}

enum TSupplierCommands {
  CreateSupplier = 'CreateSupplier',
  UpdateSupplier = 'UpdateSupplier',
  DeleteSupplier = 'DeleteSupplier'
}

export default class Supplier extends BaseModel {
  static createSupplier = collectionCommand<ICreateSupplierCmd, Supplier, typeof Supplier>(
    TSupplierCommands.CreateSupplier
  );

  deleteSupplier = command<undefined, Supplier>(TSupplierCommands.DeleteSupplier);
  updateSupplier = command<IUpdateSupplierCmd, Supplier>(TSupplierCommands.UpdateSupplier);

  @attr('string')
  code!: string;

  @attr('string')
  description?: string;

  @attr('string')
  currency?: string;

  @attr('string')
  externalId?: string;

  @attr('array')
  closedWeekDays?: number[];

  @hasMany('user-profile', { async: false, inverse: null })
  supplierPortalUsers!: UserProfile[];

  /**
   * Custom fields values
   */
  @attr({
    defaultValue: function () {
      return {};
    }
  })
  customFields?: TCustomFieldValues;

  get supplierId() {
    return this.id;
  }

  [Type] = 'supplier' as const;
}
